// Option 2: If you must use Web Crypto API, process in batches
import { Broadcast } from "../classes/Broadcast"
import type { AsyncSequence } from "../types/AsyncSequence"
import { ProcessIterable } from "./ProcessIterable"

export const CopyIterable = <T>(
  input: AsyncSequence<T>,
  length: number
): AsyncGenerator<T>[] => {
  const { stop, push, subscribe } = Broadcast<T>()
  const result = Array.from({ length }, subscribe)
  void ProcessIterable(input, push, stop)
  return result
}
